/**
 * Copyright SimVentions, Inc. Usage, distribution, transferal, and licensing
 * of this source code is protected under SBIR law as described in DFARS 252.227-7018.
 *
 * SBIR data rights fully described in the README.md file in the top level directory of this project.
 */

export const keyboardShortcutsContent = `
## Keyboard Shortcuts

Dexter supports several keyboard shortcuts to speed up your workflow.

### General

| Shortcut | Action |
|----------|--------|
| \`Delete\` or \`Backspace\` | Delete selected node or edge |
| \`Shift + Drag\` | Box select nodes |

### Mapping Canvas Navigation

| Shortcut | Action |
|----------|--------|
| \`Click + Drag\` | Pan canvas |
| \`Mouse Wheel\` | Zoom in/out |
| \`Double Click\` | Fit view |

### Node Operations

| Shortcut | Action |
|----------|--------|
| \`Click + Drag\` node | Move node |
| \`Drag\` from handle | Create connection |
| \`Click\` node title | Edit node name (if supported) |

### Tips

- Use Shift liberally for multi-selection operations
- Hold Shift while dragging on background for box selection
- Delete key works on both nodes and edges when selected
`;
